import { takeEvery, select } from 'redux-saga/effects'
import moment from 'moment'

import { LOCATION_CHANGE } from 'browser-location'
import { CONFIGURATION_RECEIVED } from 'wordpress/constants'
import { localeSelector } from 'i18n/selectors'

export default function* rootSaga() {
    let previousLocale = yield select(localeSelector)

    moment.locale(previousLocale)

    yield takeEvery([LOCATION_CHANGE, CONFIGURATION_RECEIVED], function*() {
        const locale = yield select(localeSelector)

        if (locale !== previousLocale) moment.locale(locale)

        previousLocale = locale
    })
}
